import ReportsPage from '@/pages/admin/ReportsPage/ReportsPage.vue'

export default ReportsPage
